<template>
  <div>

    <!--  顶部  -->
    <div class="top_style">
      <div style="width: 170px; float:left; margin-left: 30%;">
        <el-image style="margin-top: 150px;height: 250px; width: 170px;"  :src="require('@/assets/img/slider1.png')"></el-image>
      </div>
      <div style="width: 30%; float:left; margin-left: 5%;margin-right: 20%; text-align:left;">
        <el-row style="margin-top: 180px;color: #FFFFFF;font-size: 35px;">伊陌漂流瓶</el-row>
        <el-row style="margin-top: 30px;color: #FFFFFF;font-size: 18px;">伊陌交友是为孤单的你打造的全新的实时互动社交平台,带给你意想不到的社交体验。</el-row>
        <el-row style="margin-top: 30px; ">
          <el-button>
            <el-image style="height: 15px; width: 15px;margin-right: 10px;margin-top: -3px;" :src="require('@/assets/img/AndroidLog.png')"></el-image> Android
          </el-button>
          <el-button>
            <el-image style="height: 15px; width: 15px;margin-right: 10px;margin-top: -3px;" :src="require('@/assets/img/IOSLog.png')"></el-image> IOS
          </el-button>
        </el-row>
      </div>
    </div>

    <!-- 应用截图 -->
    <div class="app_screenshots">
      <el-row justify="space-around" style="width:1000px; margin:0 auto; ">

        <el-row>
          <el-col :span="8" style="height: 80px;">
            <br>
            <hr/>
            <hr/>
          </el-col>
          <el-col :span="8">
            <div style="text-align:center;color: #00AEFF;font-size: 30px;"> 应用截图</div>
          </el-col>
          <el-col :span="8" style="height: 80px;">
            <br>
            <hr/>
            <hr/>
          </el-col>
        </el-row>

        <el-row>
            <div style="text-align:center; font-size: 14px; ">
              找附近的人,做快乐的事。伊陌交友是为孤单的你打造的全新的实时互动社交平台,带给你意想不到的社交体验。
              <br>
              在这里你可以同城陌陌生人约 会交友陪玩,探探你附近的单身异性,和你附近陌生人来一场浪漫的约会。
              <br>
              美女帅哥应有尽有,让你感受零距离的邂逅。
            </div>
        </el-row>

        <el-row :gutter="30" style="margin-top: 80px;margin-bottom: 100px;">
          <el-col :span="6">
            <el-image style="width: 100%;" :src="require('@/assets/img/main/1.png')" fit="contain"></el-image>
          </el-col>
          <el-col :span="6">
            <el-image style="width: 100%;" :src="require('@/assets/img/main/2.png')" fit="contain"></el-image>
          </el-col>
          <el-col :span="6">
            <el-image style="width: 100%;" :src="require('@/assets/img/main/3.png')" fit="contain"></el-image>
          </el-col>
          <el-col :span="6">
            <el-image style="width: 100%;" :src="require('@/assets/img/main/4.png')" fit="contain"></el-image>
          </el-col>
        </el-row>
      </el-row>
    </div>

    <el-footer style="text-align:center; ">
      <div>
        连云港伊陌网络科技有限公司 <a href="https://beian.miit.gov.cn/" style="color: #000000;"> @Closer 2023.苏ICP备2023033521号-1</a>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>
<style>
.top_style {
  height: 400px;
  min-width: 1140px;
  width: 100%;
  background: url('../assets/img/background2.png');
  /*background-size: auto 100%;*/
  background-size: cover;
}

.app_screenshots {
  margin-top: 60px;
}
</style>
